import React from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { isConsumerArea } from '../../CommonSelectors/CommonAreaSelector';
import { ClientFooter } from '../../ConsumerArea/components/Footer/FooterView';
import { theme } from '../BeFi20.meta';
import { Overview } from './Overview';
import { Box } from '../../CommonComponents/OPL/Box/Box';

interface Props {
  isMobile?: boolean;
}

export default ({ isMobile }: Props) => {
  const isClientArea = useSelector(isConsumerArea);

  return (
    <ThemeProvider theme={theme}>
      <Overview />

      {isClientArea && <ClientFooter />}

      {/* This hack is needed to accommodate the web-mobile bottom navbar */}
      {/* The isMobile flag comes from the renderMobile method of ConsumerAreaView.jsx */}
      {isMobile && <Box pb={72} />}
    </ThemeProvider>
  );
};
